import { SCHEMA_ADD } from './types';

export const getDayData = (trekId, day) => {
  return async (dispatch, getState, api) => {
    const { token } = getState().user;
    try {
      const { data } = await api.getDayData(trekId, day, 'get', token);
      // if (data === null) {
      // setTimeout(() => dispatch(getDayData(trekId, day)), 4000);
      // } else {
      dispatch(storeDayData(data));
      // }
    } catch (err) {
      // if (err.response.status === 404) {
      // setTimeout(() => dispatch(getDayData(trekId, day)), 4000);
      // }
      console.log(err, 'err in day data fetch');
    }
  };
};

export const storeDayData = data => {
  return {
    type: SCHEMA_ADD,
    payload: {
      schema: 'days',
      data: {
        ...data,
        id: data.day,
      },
    },
  };
};



// WEBPACK FOOTER //
// ./src/redux/actions/dayActions.js